"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationInApp = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const notification_event_type_entity_1 = require("./notification-event-type.entity");
const look_up_entity_1 = require("./look-up.entity");
let NotificationInApp = class NotificationInApp {
};
exports.NotificationInApp = NotificationInApp;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], NotificationInApp.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "event_type_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], NotificationInApp.prototype, "eventTypeId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "user_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], NotificationInApp.prototype, "userId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)(),
    tslib_1.__metadata("design:type", String)
], NotificationInApp.prototype, "subject", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)("text"),
    tslib_1.__metadata("design:type", String)
], NotificationInApp.prototype, "body", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", default: 451 }),
    tslib_1.__metadata("design:type", Number)
], NotificationInApp.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], NotificationInApp.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_at" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], NotificationInApp.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], NotificationInApp.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => notification_event_type_entity_1.NotificationEventType),
    (0, typeorm_1.JoinColumn)({ name: 'event_type_id' }),
    tslib_1.__metadata("design:type", typeof (_d = typeof notification_event_type_entity_1.NotificationEventType !== "undefined" && notification_event_type_entity_1.NotificationEventType) === "function" ? _d : Object)
], NotificationInApp.prototype, "eventType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: 'status_lid' }),
    tslib_1.__metadata("design:type", typeof (_e = typeof look_up_entity_1.LookUp !== "undefined" && look_up_entity_1.LookUp) === "function" ? _e : Object)
], NotificationInApp.prototype, "status", void 0);
exports.NotificationInApp = NotificationInApp = tslib_1.__decorate([
    (0, typeorm_1.Entity)("notification_in_app")
], NotificationInApp);
